import React from "react";
import Loader from "react-loader-spinner";

function Button({ onClick, title, loading = false }) {
  if (!loading)
    return (
      <div
        className="PayButton"
        style={{ backgroundColor: "#2c3e50" }}
        onClick={onClick}
      >
        {title}
      </div>
    );
  return (
    <div className="PayButton" style={{ backgroundColor: "#2c3e50" }}>
      <Loader type="ThreeDots" color="white" height={5} width={20} />
    </div>
  );
}

export default Button;
